import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
  }
})

export default {
  [types.SET_LOBBY_BANNER] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.lobbybanner = payload
  },
  [types.SET_LOBBY_BANNERS] (state, payload) {
    state.lobbybanners = payload.data
    state.pagination = payload.meta.pagination
  }
}
